@for (alert of alerts; track alert; let index = $index) {
  <span>
    <ev-alert [type]="alert.type" (closeEmitter)="closeAlert(index)">
      <div [innerHTML]="alert.msg"></div>
    </ev-alert>
  </span>
}

